<template>
    <div id="app">
        <router-view v-if="!$route.meta.keepAlive"></router-view>
        <keep-alive v-if="$route.meta.keepAlive">
            <router-view />
        </keep-alive>
    </div>
</template>

<script>
export default {
    name: "App",
};
</script>
<style>

</style>
<style>
@import '../static/app.css';

</style>



// WEBPACK FOOTER //
// src/App.vue